export default "__VITE_ASSET__33A1A15v__"